import { render } from "./PasswordReset.vue?vue&type=template&id=149a18e2&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=149a18e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149a18e2"]])

export default __exports__